import React, { useEffect, useState } from 'react'
import './ChildComponent.css';
import dayjs from 'dayjs';
import { InputGroup, FormControl, Badge } from 'react-bootstrap';
import { updateChildVerifyFromGrid, updatePNC } from '@store/actions/beneficiaryAction';
import { useDispatch, useSelector } from 'react-redux';
import { desiredFormatDate, formatDateBasedOnTimeZone } from '@utils/commonUtils';
import { updateChild } from '@store/actions/beneficiaryAction';
import DetailRow from '@components/common/DetailRow';
import { COMMON_CONSTANTS, DATA_TYPES, dateFormate, GENDER, YES_NO_OPTIONS } from '@constants/index';
import { CHILD_COMMON_CONSTANTS, CHILD_DETAILS, CHILD_OVERVIEW_LABELS } from './ChildtrackingConstant';
import Button from '@components/common/Button';
import CreateAndVerifyModal from './CreateAndVerifyModal';
import endpoints from '@config/endpoints';
import { getData } from '@services/CommonApiService';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import { errorLogger } from '@utils/applicationLogUtils';
import { RootState } from '@store/reducers';
import { buttonNames } from '@constants/appConstants';
import { DeathDetailsDataView } from './ChildServices/NewBorn/NewBornForm/NewBornConstants';
import ChildKycModal from './ChildKycModal';
import { getDefaultDetails, getDefaultHeader } from '@utils/childUtils';

interface childProps {
  currentChild: any;
  beneficiary: any;
  flow: string;
}

interface objectType {
  isError: boolean;
  message: string;
  isDisable: boolean;
  value: any;
}

export interface formStateType {
  [key: string]: objectType;
}

const ChildDetailsView = (props: childProps) => {
  const { currentChild, beneficiary, flow } = props;
  const dispatch = useDispatch();
  const [showVerifyChildModal, setShowVerifyChildModal] = useState<boolean>(false);
  const [deathDetails, setDeathDetails] = useState<any>(DeathDetailsDataView);
  const [showChildModal, setShowChildModal] = useState<boolean>(false);
  
  const childVerifyFromGrid = useSelector((state: RootState) => state.beneficiary.childVerifyFromGrid);
  const isKYCLoading = useSelector((state: RootState) => state.beneficiary.isKYCLoading);
  const parentAbha = useSelector((state: RootState) => state.beneficiary.parentAbha);
  const isKYCVerified = useSelector((state: RootState) => state.beneficiary.isKYCVerified);
  const userDetails = localStorage.getItem('userDetails');
  const decodedUserData = JSON.parse(decodeWithKeyAndShift(userDetails));
  const [healthProviderName, setHealthProviderName] = useState<string>('');
  const getFacilityAndServiceProviderDetails =  (child: any) => {
    const buildFullName = (data: any) => {
      if (!data) return '';
      return [data.first_name, data.middle_name, data.last_name].filter(Boolean).join(' ');
    };

    const joinNames = (names: any) => {
      if (Array.isArray(names)) {
        return names.filter(Boolean).join(', ');
      }
      return names || '';
    };
    if (child?.facility_id?.length>0 && (child?.healthprovider_id===null || !child?.healthprovider_id?.length)) {
      const finalSet =
      {
        healthProviderName:
          healthProviderName
          || '',
        mobiliserName:
          joinNames(child?.mobiliser_f_name)
          || '',
        facilityType:
          child?.facility_type?.[0]
          || '',
        facilityName:
          child?.facility_name?.[0]
          || '',
      };
      return finalSet;
    }

    return {
      healthProviderName:
        child?.health_provider_name?.[0]
        || child?.parent_health_provider_name?.[0]
        || '',
      mobiliserName:
        joinNames(child?.mobiliser_f_name)
        || joinNames(child?.parent_mobiliser_name)
        || '',
      facilityType:
        child?.facility_type?.[0]
        || child?.parent_facility_type?.[0]
        || '',
      facilityName:
        child?.facility_name?.[0]
        || child?.parent_facility_name?.[0]
        || '',
    };
  };
  const [isChildLogin, setIsChildLogin] = useState<boolean>(false);
  const parentLabel = currentChild?.relationship_name;

  const formatDate = (date: any) => {
    const dateObject = new Date(date);

    const options: any = { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = dateObject.toLocaleString('en-GB', options).split('/').reverse().join('-');
    dispatch(updatePNC('currChildDOB', formattedDate));
    dispatch(updatePNC('childBenfId', currentChild?.childId));
    return dayjs(formattedDate).format(CHILD_DETAILS.DATE_FORMATE);
  }

  const getCombinedGuardianDetails = (guardianDetails: any[]) => {
    if (!guardianDetails || guardianDetails.length === 0) return null;

    const relationshipTypes = guardianDetails.map((guardian) => guardian.relationship_type);
    const header = relationshipTypes.join('/');

    const combinedDetails = guardianDetails.flatMap((guardian) => {
      const { guardian_name, guardian_mob, relationship_type } = guardian;

      return [
        { label: `${relationship_type}'s Name`, value: guardian_name },
        { label: `${relationship_type}'s Mobile Number`, value: guardian_mob },
      ];
    });

    return {
      header: `${header}'s Details`,
      details: combinedDetails,
    };
  };

  const handleKYCClick = () => {
    setShowChildModal(true);
    setIsChildLogin(true);
    dispatch(updateChild("childBalAbha", currentChild?.bal_abha_id));
  };
  const getHealthProviderData=async()=>{
      if (currentChild?.facility_id?.length>0 && (currentChild?.healthprovider_id===null || !currentChild?.healthprovider_id?.length)) {
      const Health_provider = await getData<any>(`${endpoints.getHealthProviderTagged(currentChild?.facility_id?.[0])}`);
      const healthProviderNames = Health_provider?.data?.length === 1 ? Health_provider?.data?.map((provider: any) => `${provider.f_name} ${provider.l_name}`) : [];
      const healthProviderName = healthProviderNames?.length>0?healthProviderNames?.[0]:'';
        setHealthProviderName(healthProviderName);
    }
  }
  useEffect(() => {
    mapDataToDeathForm(currentChild);
    getHealthProviderData();
  }, []);

  useEffect(() => {
    const fetchBenfChildDetails = async () => {
      try {
        if (currentChild?.parent_id) {
          const childDetailsResponse = await getData<any>(`${endpoints.getChildBeneficiaries}/${currentChild?.parent_id}`);
          const response = await getData<any>(`${endpoints.getBeneficiaryById}/${currentChild?.parent_id}`);
          const childDobs = childDetailsResponse.data[0]?.map((item: any) => {
            return formatDateBasedOnTimeZone(item?.dob)
          });
          const childBalABHAIds = childDetailsResponse.data[0]?.map((item: any) => item.bal_abha_id);
          const reqData = {
            beneficiary: response.data[0],
            childDobs: childDobs,
            beneficiaryDetails: response.data[0],
            childData: currentChild,
            childBalABHAIds: childBalABHAIds,
            childBenfId: currentChild?.benef_id
          };
          const encodedData = encodeWithKeyAndShift(JSON.stringify(reqData));
          dispatch(updateChild('verifyChildFromGridData', encodedData));
        }
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }

    if (childVerifyFromGrid && ((parentAbha && currentChild?.parent_abha_id) ? parentAbha === currentChild?.parent_abha_id : '')) {
      fetchBenfChildDetails();
    }
  }, [childVerifyFromGrid])

  const combinedGuardianDetails = getCombinedGuardianDetails(currentChild?.guardian_details);

  const handleCreateClick = async () => {
    setShowVerifyChildModal(true);
    dispatch(updateChild("updateChildVerifyFromView", true));
    dispatch(updateChildVerifyFromGrid(true));
    dispatch(updateChild("parentAbha", currentChild?.parent_abha_id));
  }

  const mapDataToDeathForm = (data: any) => {
    const updatedDeathDetails = { ...DeathDetailsDataView };

    try {
      Object.entries(data).forEach(([key, value]) => {
        if (updatedDeathDetails[key]) {
          if (key === 'date_of_death') {
            updatedDeathDetails['date_of_death'].value = desiredFormatDate(value, dateFormate.dd_mm_yyyy);
            if (updatedDeathDetails['timeOfDeath']) {
              updatedDeathDetails['timeOfDeath'].value =
                currentChild?.place_of_death_code !== null
                  ? desiredFormatDate(value, dateFormate.hh_mm_A)
                  : '-';
            }
          } else {
            updatedDeathDetails[key].value = (typeof value === DATA_TYPES.BOOLEAN) ? value ? YES_NO_OPTIONS.YES : YES_NO_OPTIONS.NO : value;
          }
        }
      });
      setDeathDetails(updatedDeathDetails);
    } catch (err) {
      errorLogger('Error mapping death details:', err);
    }

  };
  
  const handleCloseKycModal = () => {
    setShowChildModal(false);
    setIsChildLogin(false);
  };

  useEffect(() => {
    return () => {
      dispatch(updateChild('isKYCLoading', false));
    };
  }, []);

  return (
    <>
      {isKYCLoading && <span className="childViewloader"></span>}
      <div className="child-view-content">
        <div className="child-view-details">
          <div className="child-view-header-container">{CHILD_OVERVIEW_LABELS.CHILD_DETAILS_HEADER}</div>
          <div className="child-details">
            <DetailRow label={CHILD_OVERVIEW_LABELS.NAME_OF_CHILD} value={currentChild?.benf_name} />
            {flow === 'view' ? (
              currentChild?.bal_abha_id ? (<div className='abhaVerifiedcontainer'>
                <div className='balabha-container'>
                    <DetailRow
                      label={CHILD_OVERVIEW_LABELS.BAAL_ABHA_ID}
                      value={currentChild?.bal_abha_id}
                  />
                  <div className={isKYCVerified ? 'abhaverified' : ''}>
                      {isKYCVerified ? 'Verified' : ''}
                  </div>
                </div>
                {currentChild?.bal_abha_id && (!currentChild?.is_kyc_verified && !isKYCVerified) && <Button
                    onClick={handleKYCClick}
                    disabled={false}
                    id=""
                    buttonName={buttonNames.ADD_KYC}
                    colorType="primary-2"
                    icon=""
                    iconPosition=""
                />}
            </div>

            ) : (
                <DetailRow
                  label={CHILD_OVERVIEW_LABELS.BAAL_ABHA_ID}
                  value={'-'} />
              )) : (<div key="childAbha" className="childAbha_wrapper">
                <div className="ip-with-label">
                  <label className="label-name-required-for-ip">
                    BAAL ABHA ID
                  </label>
                  <div className="create-button-clickable-button">
                    <Button
                      onClick={handleCreateClick}
                      disabled={currentChild?.is_dead || !currentChild?.parent_abha_id || currentChild?.bal_abha_id}
                      id=""
                      buttonName={buttonNames.linkAbha}
                      colorType="primary"
                      icon=""
                      iconPosition="" />
                  </div>
                </div>
              </div>)}

            <DetailRow label={CHILD_OVERVIEW_LABELS.PARENT_NAME(parentLabel)} value={currentChild?.parent_name} />
            <DetailRow label={CHILD_OVERVIEW_LABELS.PARENT_ABHA_ID(parentLabel)} value={currentChild?.parent_abha_id} />
            <DetailRow label={CHILD_OVERVIEW_LABELS.PARENT_MOBILE_NUMBER(parentLabel)} value={currentChild?.parent_mob} />
            <DetailRow label={CHILD_OVERVIEW_LABELS.DATE_OF_BIRTH} value={currentChild?.dob ? formatDate(currentChild?.dob) : '-'} />
            <DetailRow label={CHILD_OVERVIEW_LABELS.MATURITY} value={currentChild?.maturity_status_name} />
            <DetailRow label={CHILD_OVERVIEW_LABELS.WEIGHT_AT_BIRTH} value={currentChild?.weight_at_birth_in_gm ? `${currentChild?.weight_at_birth_in_gm} gms` : '-'} />
            <DetailRow label={CHILD_OVERVIEW_LABELS.DATE_OF_REGISTRATION} value={currentChild?.registration_date ? formatDate(currentChild?.registration_date) : '-'}/>
            <DetailRow label={CHILD_OVERVIEW_LABELS.TIME_OF_REGISTRATION} value={currentChild?.registration_date ?  desiredFormatDate(currentChild?.registration_date, dateFormate.hh_mm_A) : '-'}/>
          </div>
        </div>
        {combinedGuardianDetails ? (
          <div className="child-view-details">
            <div className="child-view-header-container">{combinedGuardianDetails.header}</div>
            <div className="child-details">
              {combinedGuardianDetails?.details?.map((detail, idx) => (
                <DetailRow key={idx} label={detail.label} value={detail.value} />
              ))}
            </div>
          </div>
        ) : (
          <div className="child-view-details">
            <div className="child-view-header-container">
              {getDefaultHeader(currentChild?.parent_gender_name, currentChild?.relationship_name)}
            </div>
            <div className="child-details">
              {getDefaultDetails(currentChild?.parent_gender_name, currentChild?.relationship_name,
                currentChild?.is_mother_alive).map((detail, idx) => (
                  <DetailRow key={idx} label={detail.label} value={detail.value} />
                ))}
            </div>
          </div>
        )}
        {( () => {
          const details:any = getFacilityAndServiceProviderDetails(currentChild);
          return <>
            <div className="child-view-details">
              <div className="child-view-header-container">{CHILD_OVERVIEW_LABELS.SERVICE_PROVIDERS_HEADER}</div>
              <div className="child-details">
                <DetailRow label={CHILD_OVERVIEW_LABELS.HEALTH_PROVIDER_NAME} value={details.healthProviderName} />
                <DetailRow label={CHILD_OVERVIEW_LABELS.ASHA} value={details.mobiliserName} />
              </div>
            </div>
            <div className="child-view-details">
              <div className="child-view-header-container">{CHILD_OVERVIEW_LABELS.FACILITY_DETAILS_HEADER}</div>
              <div className="child-details">
                <DetailRow label={CHILD_OVERVIEW_LABELS.FACILITY_TYPE} value={details.facilityType} />
                <DetailRow label={CHILD_OVERVIEW_LABELS.FACILITY_NAME} value={details.facilityName} />
              </div>
            </div>
          </>;
        })()}
        {currentChild?.is_dead &&<div className="child-view-details">
          <div className="child-view-header-container">{'Death Details'}</div>
          <div className="child-details">
          {deathDetails && 
                    Object.keys(deathDetails).map((key) => {
                    return (
                        <DetailRow
                        key={key}
                        label={deathDetails?.[key]?.title}
                        value={deathDetails?.[key]?.value}
                        />
                    );
                    })}
          </div>
        </div>}
      </div>
      <CreateAndVerifyModal
        showModal={showVerifyChildModal}
        handleClose={()=>setShowVerifyChildModal(false)}
      />
      <ChildKycModal currentChild={currentChild} flow={flow} showChildKycModal={showChildModal} isChildKycLogin={isChildLogin} onClose={handleCloseKycModal}/>
    </>
  );
};

export default ChildDetailsView;
